import React, { useEffect, useState } from 'react';
import { Check, FileText, Heart, Compass, AlertTriangle, Clock } from 'lucide-react';
import { Section } from './Shared';
import { Pricing } from './Pricing';
import { CandleFlame, TearDrop } from './SacredIcons';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 7,
    s: 57
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('constelaciones-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 68;
  });
  useEffect(() => {
    sessionStorage.setItem('constelaciones-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-217">
      <div className="bg-brand-violet text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-goldLight/40" data-id="element-218">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-xs font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-219">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-220">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-gold/40 bg-gradient-to-br from-white/95 to-brand-goldLight/10 shadow-[0_10px_40px_rgba(201,169,97,0.12)]" data-id="element-221">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-222">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-goldDark shrink-0" data-id="element-223" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-violetDark text-center" data-id="element-224">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-225">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-226" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-227">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-228" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-229">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-230" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-231">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-232" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-233">
            Después sube $10.000 ARS.{' '}
            <span className="text-brand-violet" data-id="element-234">No vuelve.</span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-gold/30" data-id="element-235">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-236">
            <div className="flex items-center gap-2" data-id="element-237">
              <span className="relative flex h-2.5 w-2.5" data-id="element-238">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-burgundy opacity-75" data-id="element-239"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-burgundy" data-id="element-240"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-241">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-violet uppercase tracking-wide" data-id="element-242">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-gold/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-243">
            <div className="bg-gradient-to-r from-brand-gold to-brand-goldDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-244" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-245">
            <strong className="text-brand-violet" data-id="element-246">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const tomos = [{
  num: '01',
  title: 'TOMO 1 — PROTOCOLO DE ENCUADRE SISTÉMICO',
  tagline: 'La base que ordena todo lo que viene después.',
  color: 'text-brand-violet',
  bgColor: 'bg-brand-violet/5',
  borderColor: 'border-brand-violet/20',
  bullets: ['Protocolo de primera entrevista sistémica', 'Ficha de admisión completa e imprimible', 'Cuestionario de exclusiones del sistema', 'Consentimiento informado adaptado a constelaciones', 'Checklist de preparación del espacio', 'Protocolo de encuadre individual y grupal', 'Guía de honorarios y acuerdo terapéutico']
}, {
  num: '02',
  title: 'TOMO 2 — CARTOGRAFÍA DEL CAMPO',
  tagline: 'El mapa que te permite ver el sistema antes de intervenir.',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/5',
  borderColor: 'border-brand-gold/20',
  bullets: ['Simbología técnica completa del genograma sistémico', 'Plantillas imprimibles de 2, 3 y 4 generaciones', 'Protocolo de construcción paso a paso', 'Guía de lectura de patrones transgeneracionales', 'Mapa de los 8 patrones más frecuentes', 'Planilla de análisis del genograma', 'Detección de aniversarios sistémicos']
}, {
  num: '03',
  title: 'TOMO 3 — BITÁCORA FENOMENOLÓGICA',
  tagline: 'El seguimiento que convierte sesiones en procesos.',
  color: 'text-brand-forest',
  bgColor: 'bg-brand-forest/5',
  borderColor: 'border-brand-forest/20',
  bullets: ['Planilla de seguimiento sesión a sesión (Cara A y B)', 'Sistema de notación rápida de movimientos del campo', 'Planilla de registro individual y grupal', 'Banco de frases sanadoras con registro de efectividad', 'Indicadores de avance y estancamiento del proceso', 'Planilla de evolución cada 5 sesiones', 'Planilla de cierre de proceso']
}, {
  num: '04',
  title: 'TOMO 4 — VADEMÉCUM DE INTERVENCIÓN',
  tagline: 'La guía de consulta rápida para cuando el campo se detiene.',
  color: 'text-brand-violetLight',
  bgColor: 'bg-brand-violetLight/10',
  borderColor: 'border-brand-violetLight/30',
  bullets: ['Tabla maestra de síntomas y su lectura sistémica', 'Intervenciones para conflictos de pareja', 'Protocolo para conflictos parentales y con hijos', 'Trabajo con duelos bloqueados y muertes sin lugar', 'Detección e intervención en trauma transgeneracional', 'Lectura sistémica de adicciones y conductas repetitivas', 'Síntomas físicos sin causa orgánica']
}, {
  num: '05',
  title: 'TOMO 5 — PROTOCOLO DE DESPEDIDA Y CUIDADO',
  tagline: 'El cierre que completa el círculo y cuida al terapeuta.',
  color: 'text-brand-violetDark',
  bgColor: 'bg-brand-violetDark/5',
  borderColor: 'border-brand-violetDark/20',
  bullets: ['Señales de que un proceso está listo para cerrar', 'Protocolo completo de sesión de despedida', 'Planillas de cierre y carta de cierre opcional', 'Sistema de diseño y seguimiento de tareas', 'Ritual de limpieza post-sesión y cierre de jornada', 'Bitácora personal del terapeuta', 'Planilla de preparación para supervisión']
}];
const bonuses = [{
  icon: Heart,
  title: 'BONUS 1 — KIT EXPRESS DE FRASES SANADORAS',
  pages: '~25 páginas · listo para imprimir',
  color: 'text-brand-violet',
  bgColor: 'bg-brand-violet/10',
  borderColor: 'border-brand-violet/30',
  desc: 'La frase justa en el momento exacto. Banco clasificado por vínculo y conflicto, con protocolo de elección en 60 segundos.',
  bullets: ['Frases clasificadas por padre, madre, pareja, hijos, excluidos, duelo', 'Mapa rápido de qué frase usar según lo que muestra el campo', 'Checklist pre-frase y post-frase', 'Tarjetas recortables para tener en sesión'],
  price: '$12.000'
}, {
  icon: FileText,
  title: 'BONUS 2 — AGENDA CLÍNICA SISTÉMICA DE 30 DÍAS',
  pages: '~25 páginas · listo para imprimir',
  color: 'text-brand-burgundy',
  bgColor: 'bg-brand-burgundy/10',
  borderColor: 'border-brand-burgundy/30',
  desc: 'Ordená tu práctica en 30 días. Planificación mensual, semanal y diaria con trackers.',
  bullets: ['Calendario mensual imprimible', 'Planes semanales semana 1 a 4', 'Tracker de pacientes activos y pagos', 'Auto-chequeo semanal del terapeuta'],
  price: '$10.000'
}, {
  icon: Compass,
  title: 'BONUS 3 — PROTOCOLOS RÁPIDOS PARA PRIMERA SESIÓN Y SEGUIMIENTO',
  pages: '~25 páginas · listo para imprimir',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  desc: 'Claridad total sobre qué preguntar, qué registrar y qué mirar desde la primera sesión.',
  bullets: ['Protocolo de primera sesión en 7 pasos', 'Ficha breve de primera sesión imprimible', 'Checklist de señales sistémicas', 'Protocolo de qué hacer si llega en crisis o no vuelve'],
  price: '$10.000'
}];
const planComparison = [{
  situation: 'El campo se detiene y no sabés hacia dónde ir',
  without: 'Improvisás o cambiás de tema',
  with: 'Protocolo de intervención avanzada. Dirección clara.'
}, {
  situation: 'El consultante llega resistente y no se mueve',
  without: 'Forzás el proceso o te frustrás',
  with: 'Lectura sistémica de la resistencia aplicada en sesión'
}, {
  situation: 'Sentís que te perdiste en el campo del consultante',
  without: 'No sabés distinguir si es tuyo o del campo',
  with: 'Protocolo de contratransferencia sistémica.'
}, {
  situation: 'Querés trabajar trauma profundo con seguridad',
  without: 'Evitás el tema o lo abrís sin contención',
  with: 'Protocolo de regulación somática paso a paso'
}, {
  situation: 'Tenés dificultad para cobrar lo que vale tu trabajo',
  without: 'Seguís con honorarios bajos por creencia propia',
  with: 'Revisión sistémica del propio sistema económico'
}, {
  situation: 'No sabés cuándo cerrar un proceso',
  without: 'Lo extendés más de lo necesario',
  with: '7 señales de cierre y protocolo de despedida de maestría'
}, {
  situation: 'Sesiones que no tienen la profundidad que querés',
  without: 'La técnica está pero falta algo',
  with: 'Desarrollo de la presencia vacía como instrumento'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-247">
      {/* Decorative Sacred elements */}
      <CandleFlame className="hidden lg:block absolute top-20 right-[3%] w-8 h-12 opacity-25 animate-float-soft" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-248" />
      <TearDrop className="hidden lg:block absolute top-60 left-[2%] w-10 h-12 opacity-30 animate-float-soft" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-249" />

      <div className="text-center mb-12" data-id="element-250">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-gold/40 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-251">
          <span className="text-xl" data-id="element-252">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-violetDark text-sm md:text-base" data-id="element-253">
            KIT CONSTELACIONES FAMILIARES™
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-4 leading-tight text-brand-violetDark" data-id="element-254">
          5 Tomos + 3 Bonus
        </h2>
        <p className="text-brand-text/70 text-base md:text-lg" data-id="element-255">
          375 páginas — Todo resuelto.
        </p>
      </div>

      {/* Main Kit block */}
      <div className="max-w-4xl mx-auto mb-12" data-id="element-256">
        <div className="relative z-10 w-full max-w-[320px] sm:max-w-md md:max-w-lg lg:max-w-xl mx-auto mb-10 flex justify-center" data-id="element-257">
          <img src="https://cdn.magicpatterns.com/uploads/byqwgSXsTmDsi2yu1KAa8w/Mockup_Constelaciones_Familiares.png" alt="Kit Constelaciones Familiares" className="w-full h-auto drop-shadow-2xl" draggable={false} data-id="element-258" />
        </div>

        <div className="space-y-6" data-id="element-259">
          {tomos.map((tomo, i) => <div key={i} className={`rounded-2xl p-6 md:p-8 border ${tomo.bgColor} ${tomo.borderColor} backdrop-blur-sm shadow-sm`} data-id="element-260">
              <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-261">
                <div className={`shrink-0 text-3xl md:text-4xl font-display font-bold ${tomo.color} opacity-80`} data-id="element-262">
                  {tomo.num}
                </div>
                <div className="flex-grow" data-id="element-263">
                  <h4 className="font-serif font-bold mb-2 text-lg text-brand-violetDark" data-id="element-264">
                    {tomo.title}
                  </h4>
                  <p className="text-brand-text/90 font-medium mb-4 text-base" data-id="element-265">
                    {tomo.tagline}
                  </p>

                  <div className="bg-white/80 p-4 rounded-lg border border-brand-gold/15" data-id="element-266">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2 text-xs md:text-sm text-brand-text/85" data-id="element-267">
                      {tomo.bullets.map((bullet, j) => <div key={j} className="flex items-start" data-id="element-268">
                          <Check className={`w-4 h-4 mr-2 shrink-0 ${tomo.color}`} data-id="element-269" />
                          <span data-id="element-270">{bullet}</span>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mb-8 mt-16" data-id="element-271">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-violetDark" data-id="element-272">
            🎁 3 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-goldDark mt-1 font-bold" data-id="element-273">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-274">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          const numberLabel = String(i + 1).padStart(2, '0');
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-gold/30 relative overflow-hidden bg-white/90 flex flex-col" data-id="element-275">
                <div className={`absolute top-3 left-3 ${bonus.bgColor} border ${bonus.borderColor} ${bonus.color} text-[11px] font-mono font-bold px-2 py-0.5 rounded-md`} data-id="element-276">
                  {numberLabel}
                </div>
                <div className="absolute top-0 right-0 bg-brand-goldDark text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-277">
                  GRATIS
                </div>
                <Icon className={`w-7 h-7 ${bonus.color} mb-3 mt-6`} data-id="element-278" />
                <h4 className="text-base md:text-lg font-serif font-bold mb-2 pr-14 leading-tight text-brand-text" data-id="element-279">
                  {bonus.title}
                </h4>
                <p className={`${bonus.color} text-xs font-medium mb-3`} data-id="element-280">
                  {bonus.pages}
                </p>
                <p className="text-brand-text/80 mb-4 text-xs md:text-sm" data-id="element-281">
                  {bonus.desc}
                </p>
                <div className="space-y-1.5 mb-4 flex-grow" data-id="element-282">
                  {bonus.bullets.map((bullet, j) => <div key={j} className="flex items-start text-xs text-brand-text/80" data-id="element-283">
                      <span className={`${bonus.color} mr-1.5 shrink-0`} data-id="element-284">
                        ·
                      </span>
                      <span data-id="element-285">{bullet}</span>
                    </div>)}
                </div>
                <div className="text-xs text-brand-text/50 mt-auto pt-3 border-t border-brand-gold/10" data-id="element-286">
                  <span className="line-through" data-id="element-287">{bonus.price}</span>
                  <span className="ml-2 font-bold text-brand-goldDark" data-id="element-288">
                    → GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-289">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-gold/30 bg-white/80" data-id="element-290">
            <p className="text-sm md:text-base font-medium text-brand-text/80" data-id="element-291">
              Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-292">$30.000</span>{' '}
              <span className="text-brand-violet font-bold" data-id="element-293">
                → GRATIS con tu Kit Constelaciones
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-294" />

      <Pricing data-id="element-295" />

      {/* Maestría Comparison */}
      <div className="max-w-5xl mx-auto mb-12 mt-12" data-id="element-296">
        <div className="bg-white rounded-2xl p-5 md:p-8 border border-brand-gold/30 shadow-sm" data-id="element-297">
          <p className="text-base md:text-xl font-serif font-bold text-brand-violetDark mb-6 text-center" data-id="element-298">
            🎓 ¿Qué agrega la Maestría en Consulta?
          </p>

          <div className="hidden md:block" data-id="element-299">
            <div className="grid grid-cols-3 gap-4 text-[11px] font-semibold uppercase tracking-wide text-brand-text/60 border-b border-brand-gold/20 pb-3 mb-3" data-id="element-300">
              <div data-id="element-301">Situación</div>
              <div className="text-brand-burgundy" data-id="element-302">❌ Sin Maestría</div>
              <div className="text-brand-violet" data-id="element-303">✅ Con Maestría</div>
            </div>
            <div className="space-y-3" data-id="element-304">
              {planComparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 text-xs md:text-sm text-brand-text/80 py-2 border-b border-brand-gold/10 last:border-0" data-id="element-305">
                  <div className="font-medium pr-4" data-id="element-306">{row.situation}</div>
                  <div className="text-brand-burgundy/80 pr-4" data-id="element-307">
                    {row.without}
                  </div>
                  <div className="text-brand-violet font-medium" data-id="element-308">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="md:hidden space-y-4" data-id="element-309">
            {planComparison.map((row, i) => <div key={i} className="border-b border-brand-gold/15 pb-4 last:border-0 last:pb-0" data-id="element-310">
                <p className="text-sm font-semibold text-brand-text mb-2" data-id="element-311">
                  {row.situation}
                </p>
                <div className="text-xs text-brand-burgundy/80 mb-1" data-id="element-312">
                  ❌ {row.without}
                </div>
                <div className="text-xs text-brand-violet font-medium" data-id="element-313">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>

          <p className="text-sm md:text-base font-medium text-brand-goldDark italic text-center mt-8" data-id="element-314">
            Un solo proceso mejorado con esta guía ya paga la diferencia de
            precio.
          </p>
        </div>
      </div>
    </Section>;
};